/** The master's version every project reads, in words (P-12): the version saved for projects, never the draft's. */
export const masterVersionWords = (version: number): string => `Version ${version}`;
